import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ContentItemHomeSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-secondary-v2";
import {
  ActionBar as SecondaryActionBar,
  Headline as SecondaryHeadline,
} from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";
import { HomeV2SectionTopLead } from "scmp-app/components/home-v2/section-top/lead";

/* Mobile: lead then list, stacked. Tablet up: lead column on the left, a
   vertical rule, and the four-item text list in a 300px right column. */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 1px minmax(0, 300px);
    gap: 20px;
    align-items: start;
  }
`;

export const StyledLead = styled(HomeV2SectionTopLead)`
  ${theme.breakpoints.up("tablet")} {
    gap: 10px;
  }
`;

export const ColumnDivider = styled.div`
  block-size: 1px;

  background-color: #dfdfdf;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 1px;
    block-size: 100%;
  }
`;

export const ListColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  ${theme.breakpoints.up("tablet")} {
    gap: 16px;
  }
`;

export const ItemDivider = styled.div`
  block-size: 1px;

  background-color: #dfdfdf;
`;

export const StyledListItem = styled(ContentItemHomeSecondaryV2)`
  ${SecondaryHeadline} {
    font-size: 15px;
    line-height: 140%;

    ${theme.breakpoints.up("tablet")} {
      font-size: 14px;
    }
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }
`;
